export enum PoliciesServiceActions {
  ALL = '*',
  Signals = 'signals',
  Triggers = 'triggers',
  Lists = 'lists',
  Variables = 'variables',
  History = 'history',
  Policies = '',
  NestedTriggers = 'nested-triggers',
  Default = 'default',
  Import = 'import',
  Export = 'export',
}
